import {
  SUMMARY_PERFORMANCE_TYPE,
  SUMMARY_UNDERLYING_ASSETS,
} from './product-capture-field-selectors.consts';

import { FCSelector } from '../../model/form-config.interface';
import { PERFORMANCE_TYPE_KEYS } from 'src/app/product-capture/model/consts/performance-type.const';

export const UNDERLYING_ASSETS: FCSelector = {
  formControlNames: [SUMMARY_UNDERLYING_ASSETS],
  optionsLength: [
    {
      lengthLogic: 'EQUALS',
      length: 0,
      effects: [],
      concatFieldRules: [
        {
          formControlNames: [SUMMARY_PERFORMANCE_TYPE],
          options: [
            {
              id: PERFORMANCE_TYPE_KEYS.SINGLE,
              logic: 'INCLUDE',
              effects: [
                {
                  formControlNames: [SUMMARY_PERFORMANCE_TYPE],
                  valid: false,
                },
              ],
            },
            {
              id: PERFORMANCE_TYPE_KEYS.BEST_OF,
              logic: 'INCLUDE',
              effects: [
                {
                  formControlNames: [SUMMARY_PERFORMANCE_TYPE],
                  valid: false,
                },
              ],
            },
            {
              id: PERFORMANCE_TYPE_KEYS.WORST_OF,
              logic: 'INCLUDE',
              effects: [
                {
                  formControlNames: [SUMMARY_PERFORMANCE_TYPE],
                  valid: false,
                },
              ],
            },
            {
              id: PERFORMANCE_TYPE_KEYS.BASKET,
              logic: 'INCLUDE',
              effects: [
                {
                  formControlNames: [SUMMARY_PERFORMANCE_TYPE],
                  valid: false,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      lengthLogic: 'EQUALS',
      length: 1,
      effects: [],
      concatFieldRules: [
        {
          formControlNames: [SUMMARY_PERFORMANCE_TYPE],
          options: [
            {
              id: PERFORMANCE_TYPE_KEYS.SINGLE,
              logic: 'EXCLUDE',
              effects: [
                {
                  formControlNames: [SUMMARY_PERFORMANCE_TYPE],
                  valid: false,
                },
              ],
            },
            {
              id: PERFORMANCE_TYPE_KEYS.SINGLE,
              logic: 'INCLUDE',
              effects: [
                {
                  formControlNames: [SUMMARY_PERFORMANCE_TYPE],
                  valid: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      lengthLogic: 'GREATER',
      length: 1,
      effects: [],
      concatFieldRules: [
        {
          formControlNames: [SUMMARY_PERFORMANCE_TYPE],
          options: [
            {
              id: PERFORMANCE_TYPE_KEYS.SINGLE,
              logic: 'INCLUDE',
              effects: [
                {
                  formControlNames: [SUMMARY_PERFORMANCE_TYPE],
                  valid: false,
                },
              ],
            },
            {
              id: PERFORMANCE_TYPE_KEYS.SINGLE,
              logic: 'EXCLUDE',
              effects: [
                {
                  formControlNames: [SUMMARY_PERFORMANCE_TYPE],
                  valid: true,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
